import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import {
  APIHireDubaiIcon,
  SmoothHireDubaiIcon,
  CRMHireDubaiIcon,
  RegularHireDubaiIcon,
} from "../../../app-constants";

function Facilitatehiring() {
  return (
    <div className="facilitate_hiring p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={6} xxl={6} className="resp_order">
            <Row>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
                <div className="faclitate_box">
                  <div className="facilitate_img">{APIHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Experienced Talent Pool</h6>
                    <p>
                      Hire top developers with deep domain expertise, ready to
                      drive your project's success with exceptional knowledge
                      and skills.
                    </p>
                  </div>
                </div>
                <div className="faclitate_box">
                  <div className="facilitate_img">{SmoothHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Smooth and Easy Communication</h6>
                    <p>
                      Rely on our developers for 24/7 support, guaranteeing
                      prompt resolution of your inquiries and concerns.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
                <div className="faclitate_box mt_top">
                  <div className="facilitate_img">{CRMHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Lower Training and Retaining Expenses</h6>
                    <p>
                      Minimize costs associated with employee training and
                      retention, preserving valuable resources for your
                      business.
                    </p>
                  </div>
                </div>
                <div className="faclitate_box">
                  <div className="facilitate_img">{RegularHireDubaiIcon}</div>
                  <div className="facilitate_content">
                    <h6>Regular Reporting Updates</h6>
                    <p>
                      Receive consistent updates on project progress through
                      regular reports from our dedicated development team,
                      ensuring transparency and clarity.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 my-auto "
          >
            <h2>
              How We Facilitate Hiring Your Dedicated Mobile App Development
              Team?
            </h2>
            <p>
              Efficiently hire skilled app developers for your projects,
              ensuring a seamless match for your next project.
            </p>
            <strong>
              Slash Development Costs by Over <span>70%!</span>
            </strong>
            <strong>
              Hire Top Developers with Us for Maximum Efficiency and Value
            </strong>
            <div className="faclitate_btn">
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Hire A Developer Now!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Facilitatehiring;
